import { Order, ORDER_SIDE, ORDER_STATUS, ORDER_TYPE } from "@cede/types";
import { randomNumberId } from "../random";

export class SdkOrderFactory {
  private orders: Order[] = [];

  createAndGet(data: Partial<Order> = {}) {
    const order: Order = {
      id: String(randomNumberId()),
      timestamp: 0,
      status: ORDER_STATUS.OPEN,
      pairSymbol: "",
      type: ORDER_TYPE.MARKET,
      side: ORDER_SIDE.BUY,
      price: 0,
      amount: 0,
      filled: 0,
      fee: {
        amount: 0,
        refAmount: undefined,
        tokenSymbol: "",
      },
      ...data,
    };
    this.orders.push(order);
    return order;
  }

  create(data: Partial<Order>) {
    this.createAndGet(data);
    return this;
  }

  getAll() {
    return this.orders;
  }
}
